import React from 'react'

// Components
import TextInput from 'components/input/TextInput'

// Data
import { employment } from 'utils/constants/data'

function Employment({
    values,
    errors,
    touched,
    setFieldValue,
    handleChange,
    handleBlur,
}) {

    return (
        <div className='bg-white rounded-lg mx-4 px-6 py-4 md:px-10 md:py-8 space-y-4 sm:space-y-6'>
            <p className='uppercase text-xl sm:text-2xl mb-2 md:mb-4 font-bold'>Employment</p>
            <hr className='h-1 border-none text-[#333] bg-[#333]' />
            <p className='uppercase text-lg sm:text-xl xl:text-2xl mb-2 md:mb-4 font-bold'>18. Of the following categories, which best describes your current employment status?</p>
            <p className='text-sm xl:text-base'>For casual, seasonal, contract and shift work, use the current number of hours worked per week to determine whether full time (35 hours or more per week) or part-time employed (less than 35 hours per week).</p>
            <div className='flex flex-col space-y-4'>
                {employment.map((category, i) => {
                    return (
                        <div className='flex flex-row items-center space-x-3'>
                            <div>
                                <input
                                    checked={values.employment_status === category.title}
                                    id={`employment-status-option-radio-btn-${i}`}
                                    name={`employment-status-option-${i}`}
                                    type="radio"
                                    onChange={() => setFieldValue(`employment_status`, category.title)}
                                    value={values.employment_status}
                                    className="mt-1 w-4 h-4 md:w-6 md:h-6 text-blue-600 bg-white border-gray-300 peer-checked:bg-sky-600"
                                />
                            </div>
                            <p className='text-base xl:text-lg' key={i}>{category.title}</p>
                        </div>
                    )
                })}
            </div>
            {(errors?.employment_status && touched?.employment_status) && errors.employment_status && (
                <p className='text-xs sm:text-sm xl:text-base text-red-500'>{errors.employment_status}</p>
            )}
        </div>
    )
}

export default Employment